export default function hyphenfyPhoneNumber(numberString: string) {
  return numberString.replace(/(\d{4})(\d{3})(\d{4})/, "$1-$2-$3");
}
